<style lang="less" scoped>

.vertical-center-modal{
    display: flex;
    align-items: center;
    justify-content: center;
   
}
.vertical-center-modal .ivu-modal{
    top: 0;
}
.totalNum{
    margin-top: 20px;
    font-weight: bold;
}
/deep/ .input-table{
    .ivu-input{
        border: 1px solid #fff;
    }
}
</style>

<template>
<div>
    <Modal
        class-name="vertical-center-modal"
        :value="showModel"
        :title="title"
        :footer-hide="true"
        :mask-closable="false"
        @on-cancel="cancel"
        @on-visible-change="openOrClose"  :styles="{'min-width':'960px'}">


        <Button type="info"  @click="creatData(1)" style="margin-bottom:18px; border-radius: 6px;">{{$t("deviceManage.manageModel.new")}}</Button>
        
       <Table  max-height="500" border :columns="titleName" :data="tableList.tableData" :loading="loading"></Table>
       <!-- <div class="totalNum" v-if='local=="en-US"'>Total {{totalNum}} items</div>
       <div class="totalNum" v-else>共 {{totalNum}} 条</div> -->

        <!-- 删除弹框组件 -->
      <DeleteDialog ref="deleteChild" @ievent = "ievent"  :title='$t("orderManage.deletModel.changeTitle")' :cont='$t("orderManage.deletModel.changeCont")'></DeleteDialog>
       
    </Modal>

      <SModelBox :showModel.sync="addBox.showModel" :fn="addBox.callbackFn" :editFormData="addBox.editFormData" :type="addBox.type"></SModelBox>

      
</div>
</template>
<script>
/**
 * 弹框
 * @param showModel boolean 对话框开关 true false
 * @param fn function 回调函数
 * @param type Number 类型 1添加 2编辑
 * @param editFormData Object 编辑时的数据
 */
import common from '@/common/common';
import SModelBox from './sAddModel';
import DeleteDialog from '../../common/deleteModel.vue'; // 引入删除弹框组件
import { mapState } from 'vuex'
    export default {
        props: {
            showModel: Boolean,
            fn:Function
        },
        name: "Model3",
        components: {
            SModelBox,
            DeleteDialog
        },
        data() {
            return {   
                title: this.$t('deviceManage.manageModel.title'),//弹框标题
                formData:{},
                totalNum:'20',
                loading:true,
                tableList:{//表格组
                    hasSelectData:{},//已选中的行的数据
                    tableData: []//表格数据
                },
                addBox:{//规格弹框组-移动
                    showModel:false,//弹框开关
                    callbackFn:()=>{}, //弹框的回调函数
                    editFormData:{},//编辑时传入的现有数据
                    type:1,//新增、编辑
                }
            }
        },
        watch:{
            showModel(val){
                if(val){
                    this.getData()
                }
            }
        },
        computed:{
             ...mapState(['local','selectId']),
            titleName(){
                return [
                    {
                        title: this.$t('orderManage.titleName.ProductId'),
                        'title-zh-CN':'产品编号',
                        'title-en-US':'ProductId',
                        key: 'productId',
                        with: 140
                    },
                    {
                        title: this.$t('deviceManage.manageModel.titleName.ProductName'),
                        'title-zh-CN':'经销商机型',
                        'title-en-US':'ProductId',
                        key: 'productType',
                        with: 160
                    },
                    {
                        title: this.$t('deviceManage.manageModel.titleName.Group_name'),
                        'title-zh-CN':'组织名称',
                        'title-en-US':'Group name',
                        key: 'groupName',
                        with: 180,
                        render: (h, params) => {
                            let stext = params.row.groupName
                            return h('div',{
                                attrs:{
                                    title:stext
                                }
                            },stext || '')
                        }
                    },
                  
                    {
                        title: this.$t('deviceManage.manageModel.titleName.Member'),
                        'title-zh-CN':'成员数量',
                        'title-en-US':'Member',
                        key: 'groupNumber',
                        with: 80
                    },
                    {
                        title: this.$t('deviceManage.manageModel.titleName.Remark'),
                        'title-zh-CN':'备注',
                        'title-en-US':'Remark',
                        key: 'remark',
                        with: 80,
                        render: (h, params) => {
                            let stext = params.row.remark
                            return h('div',{
                                attrs:{
                                    title:stext
                                }
                            },stext || '')
                        }
                    },
                    {
					    title: this.$t('deviceManage.manageModel.titleName.Operation'),
                        'title-zh-CN':'操作',
                        'title-en-US':'Operation',
					    with: 80,
                        key: "id",
					    render: (h, params) => {
                            let that = this
                            return [   
                                 h('Button', {
					                props: {
                                        type: "primary",
                                        size: 'small'
                                    },
                                    style:{
                                        display:'inline-block',
                                        marginRight:'20px'
                                    },
					                on: {
					                    click: () => { this.creatData(2,params.row) }
					                }
					            },that.$t("edit")),
                                h('Button', {
					                props: {
                                        type: "error",
                                        size: 'small'
                                    },
                                    style:{
                                        display:'inline-block',
                                       
                                    },
					                on: {
					                    click: () => { this.todelData(params.row) }
					                }
					            },that.$t("delete"))
                            ]
					    }
					},
                 ]
            } 

        },
        created(){
        },
        methods: {
   
            creatData(type,data={}){//新建组织
                this.cancel()
                this.addBox.showModel = true
                this.addBox.editFormData = data
                this.addBox.type = type
                this.addBox.callbackFn = () => {//回调处理
                    this.$emit('update:showModel',true);
                    //重新载入
                    this.addBox.showModel = false;
                    // this.getData();
                }

            },
            getRender(h, params, key,types){//修改组织
                return{
                    props: {
                        value: params.row[key]
                    },
                    class:"input-table",  // 定义一个类来控制单元格的样式
                    style:{
                        width:'100%!important'
                    },
                    on:{
                        'on-blur':(event) => {
                           //获取编辑行的inde和编辑字段名，对表格数据进行重新赋值，注意：与下拉框取值不一样
                           if(types == 'input'){
                                let resVal = (event.currentTarget.value).trim()
                                if(resVal==params.row[key]){
                                    return
                                }
                          		this.tableList.tableData[params.index][params.column.key] = resVal; 
                                //   +'/'+params.row.id
                                this.axios.post(this.config.urlArray.deviceGroupsSet, this.tableList.tableData[params.index]).then((result) => {
                                    common.ajaxMsg(result.data,true);
                                    this.getData()
                                    
                                }).catch((err) => {
                                   
                                    this.disabled = false;
                                });
                           }
                            
                        }
                    }
                }
            },
            todelData(item) {// 删除
                this.tableList.hasSelectData = item
                this.$refs.deleteChild.showit();
            },
            ievent() {// 删除
                // console.log('删除',this.tableList.hasSelectData.id)
                this.axios.post(this.config.urlArray.deviceGroupsDel, {id:this.tableList.hasSelectData.id}).then((result)=>{
                    common.ajaxMsg(result.data,true,()=>{
                        this.$refs.deleteChild.recancel();
                        this.getData();
                    })
                }).catch((err)=>{
                    // common.msg('error','删除失败')
                })
            },
            getData(){
    
                this.axios.post(this.config.urlArray.deviceGroupsList, {dealerId:this.selectId}).then((result) => {
                    common.ajaxMsg(result.data,false,()=>{

                        let resData = result.data.data
                        this.tableList.tableData  = resData
                        this.loading = false

                    });
                }).catch((err) => {
                    // common.msg('error','获取失败',()=>{})
                });
    
            },
            openOrClose(value) {
                if(value === true) {        
                    this.title = this.$t('deviceManage.manageModel.title')
                } else { //关闭弹框后要做的处理
                    this.resetForm();//重置表单
                }
            },
            cancel() {//对话框关闭
                this.$emit('update:showModel',false);
            },
            resetForm() {//重置表单
                this.disabled = false;//恢复提交按钮为激活状态
            }
        }
    }
</script>
